module.exports = __webpack_public_path__ + "static/media/Logotipo.e41973c2.png";